import { type ActiveTokens } from '@atlaskit/tokens';

import defaultTokenValues from '@atlaskit/tokens/token-default-values';

export type MarginValue = Extract<ActiveTokens, `space.${string}`>;

type PlotMargin = {
	bottom?: number;
	left?: number;
	right?: number;
	top?: number;
};

export const getMarginTokenValue = (margin: MarginValue | undefined): number | undefined => {
	if (!margin) {
		return undefined;
	}

	const value = defaultTokenValues[margin];

	if (value && value.endsWith('rem')) {
		const rem = value.replace('rem', '');
		const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
		const marginValue = Number(rem) * rootFontSize;

		if (isNaN(marginValue)) {
			return undefined;
		}

		return marginValue;
	}

	return undefined;
};

export const getPlotMargin = (
	margin?: MarginValue,
	marginLeft?: MarginValue,
	marginRight?: MarginValue,
	marginTop?: MarginValue,
	marginBottom?: MarginValue,
): PlotMargin => {
	const base = getMarginTokenValue(margin);

	return {
		left: marginLeft ? (getMarginTokenValue(marginLeft) ?? base) : base,
		right: marginRight ? (getMarginTokenValue(marginRight) ?? base) : base,
		top: marginTop ? (getMarginTokenValue(marginTop) ?? base) : base,
		bottom: marginBottom ? (getMarginTokenValue(marginBottom) ?? base) : base,
	};
};
